var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("JonInfo", {
    scopedSlots: _vm._u([
      {
        key: "message",
        fn: function() {
          return [
            _c("b", [_vm._v("Keine Sorge")]),
            _vm._v(", wenn du noch keine oder wenig Erfahrung hast."),
            _c("br"),
            _vm._v(
              "\n\t\tViele Arbeitgeber suchen auch Mitarbeiter, die in einen neuen Job hineinwachsen und dabei lernen\n\t\twollen."
            ),
            _c("br"),
            _vm._v("Dazu gibt es entsprechende "),
            _c("b", [_vm._v("Einarbeitung und Einschulung")]),
            _vm._v(". 👍\n\t")
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }